import React from 'react';

const TabSelector = ({ options, currentTab }) => {
  return (
    <div className="flex items-center flex-row space-x-4 my-4">
      {options.map((option) => (
        <React.Fragment key={option.id}>
          <button
            className={
              (currentTab === option.id
                ? 'text-black font-bold '
                : 'text-[#A3A3A3]') +
              ' flex items-center justify-center px-4 h-12 cursor-default'
            }
          >
            {option.label}
          </button>
          {options.indexOf(option) < options.length - 1 && (
            <div className="flex items-center space-x-4">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-6 w-6"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M17 8l4 4m0 0l-4 4m4-4H3"
                />
              </svg>
            </div>
          )}
        </React.Fragment>
      ))}
    </div>
  );
};

export default TabSelector;
